export interface StoneOrderHasOpenOrderResponse {
  hasOpenOrder: boolean;
  originType: StoneOrderOriginType;
  originId: number;
  orderId: number;
  orderStatus: StoneOrderStatusType;
}

export enum StoneOrderStatusType {
  paid = 'paid',
  canceled = 'canceled',
  failed = 'failed',
  processing_order = 'processing_order',
  processing_cancellation = 'processing_cancellation',
}

export interface StoneOrderItem {
  amount: number;
  description: string;
  quantity: number;
  code?: string;
}

export interface StoneOrderInstallment {
  documentTypeId: number;
  discountIncrease?: number;
  description: string;
  documentNumber: string;
  rateValue: number;
}

export enum StoneOrderPayerType {
  CUSTOMER = 'CUSTOMER',
  INSURER = 'INSURER',
}

export interface StoneOrderCreateRequest {
  payer: {
    id: number;
    name: string;
    email: string;
    type: StoneOrderPayerType;
  };
  items: StoneOrderItem[];
  installments: StoneOrderInstallment[];
  originType: StoneOrderOriginType;
  originId: number;
  companyId: number;
  stoneAccountId: number;
  planAccountId: number;
  documentTypeId: number;
  deviceIds: number[];
  poi_payment_settings: {
    display_name: string;
    payment_setup: {
      type: string;
      installments: number;
      installment_type: StoneOrderInstallmentType;
    };
  };
}

export enum StoneOrderRecipientType {
  CUSTOMER = 'CUSTOMER',
  INSURER = 'CUSTOMER',
}

export enum StoneOrderPaymentType {
  debit = 'debit',
  credit = 'credit',
}

export enum StoneOrderInstallmentType {
  merchant = 'merchant',
  issuer = 'issuer',
}

export enum StoneOrderOriginType {
  SALE = 'SALE',
  WORK_ORDER = 'WORK_ORDER',
}

export interface StoneOrderCreateResponse {
  id: number;
  stoneOrderId: string;
  created_at: Date;
  updated_at: Date;
}

export interface StoneOrderCancelRequest {
  orderId: number;
}
